import { createSlice } from "@reduxjs/toolkit";

type InitialState = {
  isLoading: boolean;
};

const initialState: InitialState = {
  isLoading: false,
};

const bookingPricingSlice = createSlice({
  name: "bookingPricingSlice",
  initialState,
  reducers: {
    request: (state, action) => {
      state.isLoading = true;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default bookingPricingSlice;
